import React, { useEffect, useState } from 'react';
import { useAuth } from '../Context/AuthContext';
import { toast } from 'react-toastify';

import { Card, Container, Row, Button, Form } from 'react-bootstrap';

import { db } from '../firebase-config';
import { doc, updateDoc} from 'firebase/firestore';

import StatusSpinner from '../Components/StatusSpinner';

export default function EmployeeProfile() {
    const { currentUser, currentUserInfo, updateCurrentUserInfo, updateUserPassword, showSpinner, setShowSpinner, logout } = useAuth();
    const [displayName, setDisplayName] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [retypePassword, setRetypePassword] = useState("");
    // const [newEmail, setNewEmail] = useState("");

    // const emailReg = /[A-Za-z0-9._+-]+@[A-Za-z0-9 -]+\.[a-z]{2,}/g;

    useEffect(()=>{
        setDisplayName(currentUserInfo?.tech_name !== undefined ? currentUserInfo.tech_name : "");
        // setNewEmail(currentUserInfo?.email !== undefined ? currentUserInfo.email : "");
    }, [currentUserInfo]);

    const handleDisplayNameSubmit = async (event)=>{
        event.preventDefault();
        if(displayName === undefined || displayName === ""){
            toast.error('Display Name cannot be blank');
            return null;
        }
        if(displayName.length < 3){
            toast.error('Display Name must be at least 3 characters long');
            return null;
        }
        setShowSpinner(true);
        const employeeRef = doc(db, "technicians", currentUser.uid);
        try{
            await updateDoc(employeeRef, {
                tech_name: displayName,
            });
            let tempUserInfo = {...currentUserInfo,
                tech_name: displayName
            };
            updateCurrentUserInfo(tempUserInfo);
            setShowSpinner(false);
            toast.success(`Display Name for ${currentUser.email} has been updated to ${displayName}`);
            setNewPassword("");
            setRetypePassword("");
        }catch(err){
            setShowSpinner(false);
            toast.error(`Error saving display name: ${err.message}`);
        }
    };
    const handlePasswordUpdateSubmit = async (event)=>{
        event.preventDefault();
        if(newPassword === "" || newPassword === undefined || retypePassword === "" || retypePassword === undefined ){
            toast.error('New Password and Re-Type Password fields need to be filled out to update your password');
            return null;
        }
        if(newPassword !== retypePassword){
            toast.error('New Password and Re-Type Password do not match');
            return null;
        }
        setShowSpinner(true);
        try{
            await updateUserPassword(newPassword);
            setShowSpinner(false);
            toast.success(`Password for ${currentUser.email} has been updated`);
            setNewPassword("");
            setRetypePassword("");
        }catch(err){
            setShowSpinner(false);
            toast.error(`Error updating password: ${err.message}`);
            if (err.code === 'auth/requires-recent-login') {
                logout();
            }
        }
    };

    // const handleEmailUpdateSubmit = async (event)=>{
    //     event.preventDefault();
    //     if(newEmail === "" || newEmail === undefined){
    //         toast.error('New Email cannot be blank');
    //         return null;
    //     }
    //     if (emailReg.test(newEmail) === false) {
    //         toast.error('Not a valid email format, must have an @ sign and a .');
    //         return null;
    //     }
    //     setShowSpinner(true);
    //     try{
    //         await updateUserEmail(newEmail);
    //         const employeeRef = doc(db, "technicians", currentUser.uid);
    //         await updateDoc(employeeRef, {
    //             email: newEmail,
    //         });
    //         let tempUserInfo = {...currentUserInfo,
    //             email: newEmail,
    //         };
    //         updateCurrentUserInfo(tempUserInfo);
    //         toast.success(`User Email has been updated to ${newEmail}`);
    //         setNewEmail("");
    //         setShowSpinner(false);
    //     }catch(err){
    //         setShowSpinner(false);
    //         toast.error(`Error updating password: ${err.message}`);
    //         if (err.code === 'auth/requires-recent-login') {
    //             logout();
    //         }
    //     }
    // };
    return(
        <>
            <Container fluid style={{width:"100%", paddingLeft:"65px", marginRight:"65px"}}>
                <Container fluid className="mt-5" style={{fontSize:"1.5em", letterSpacing:"0.2em"}}>
                    <Row className="justify-content-center" style={{width:"100%"}}>
                        EMPLOYEE PROFILE
                    </Row>
                </Container>
            </Container>
            <Container className="d-flex justify-content-center mt-5 mb-5" style={{minHeight: "60vh", paddingLeft:"65px", marginRight:"65px"}}>
                <div className="w-100" style={{maxWidth: "600px"}}>
                    <Card>
                        <Card.Body>
                            <Form onSubmit={handleDisplayNameSubmit}>
                                <h4>Display Name</h4>
                                <Form.Group id="display_name">
                                    <Form.Label className="d-flex align-items-start">Display name:</Form.Label>
                                    <Form.Control type="text" value={displayName} onChange={(e)=>setDisplayName(e.target.value)} required />
                                </Form.Group>
                                <Button className="w-50 btn-dark" style={{marginTop: "15px", backgroundColor:"#2596be"}} type="submit" onClick={handleDisplayNameSubmit}>Update Display Name</Button>
                            </Form>
                            <hr/>
                            <Form onSubmit={handlePasswordUpdateSubmit} className="mt-5">
                                <Form.Group id="password">
                                    <h4>Change Password</h4>
                                    <div style={{fontSize:"0.75em"}}>If it has been too long since the last time you logged in, you will be logged out to log back in.</div>
                                    <Form.Label className="d-flex align-items-start">New Password:</Form.Label>
                                    <Form.Control type="password" value={newPassword} onChange={(e)=>setNewPassword(e.target.value)} required />
                                    <Form.Label className="d-flex align-items-start">Re-Type New Password:</Form.Label>
                                    <Form.Control type="password" value={retypePassword} onChange={(e)=>setRetypePassword(e.target.value)} required />
                                </Form.Group>
                                <Button className="w-50 btn-dark" style={{marginTop: "15px", backgroundColor:"#2596be"}} type="submit" onClick={handlePasswordUpdateSubmit}>Update Password</Button>
                            </Form>
                            {/* to much is reliant on the email <hr />
                            <Form onSubmit={handleEmailUpdateSubmit} className="mt-5">
                                <Form.Group id="email">
                                    <h4>Change Email</h4>
                                    <div style={{fontSize:"0.75em"}}>If it has been too long since the last time you logged in, you will be logged out to log back in.</div>
                                    <Form.Label className="d-flex align-items-start">New Email:</Form.Label>
                                    <Form.Control type="email" value={newEmail} onChange={(e)=>setNewEmail(e.target.value)} required />
                                </Form.Group>
                                <Button className="w-50 btn-dark" style={{marginTop: "15px", backgroundColor:"#2596be"}} type="submit" onClick={handleEmailUpdateSubmit}>Update Email Address</Button>
                            </Form> */}
                        </Card.Body>
                    </Card>
                </div>
            </Container>
            {
                showSpinner &&
                <StatusSpinner />
            }
        </>
    )
}